import React, { useEffect } from "react";
import { Col } from "react-bootstrap";
import Sticky from "react-stickynode";
import { UpperRow } from "../../../library/upper-row";
import TabSelector from "../../../library/tab-selector";
import ComposeEmailContainer from "./compose-email";
import ComposeSmsContainer from "./compose-sms";
import { setNewTemplateType } from "../../../../redux/actions/new-template";
import { useDispatch } from "react-redux";
import "./style.scss";

const Index = ({ emailTemplate, setEmailTemplate }) => {
  const dispatch = useDispatch();

  const chooseTemplateType = (type) => {
    dispatch(setNewTemplateType(type));
  };

  const selectionTabs = [
    {
      key: "email",
      title: "E-post",
      content: (
        <ComposeEmailContainer
          emailTemplate={emailTemplate}
          setEmailTemplate={setEmailTemplate}
        />
      ),
    },
    {
      key: "sms",
      title: "SMS",
      content: <ComposeSmsContainer />,
    },
  ];

  const handleSelect = (type) => {
    if (type === "email") {
      dispatch(setNewTemplateType("email"));
    } else {
      dispatch(setNewTemplateType("sms"));
    }
  };

  return (
    <Col md={7} className="dashboard-new-template-left-container">
      <Sticky enabled={true} top={100}>
        <Col className="inner-dashboard-new-template-left-container">
          <UpperRow title="Utforming" />
          <TabSelector
            defaultValue="email"
            items={selectionTabs}
            onSelect={handleSelect}
          />
        </Col>
      </Sticky>
    </Col>
  );
};

export default Index;
